import React from 'react';

import { HintLink } from '../HintLink';
import { useHandlers } from '../../hooks/useHandlers';

export const ExchangeModalLink: React.FC = ({ children }) => {
  const { openExchangeModal } = useHandlers();
  return (
    <HintLink
      href="/account"
      onClick={(event: React.SyntheticEvent) => {
        event.stopPropagation();
        event.preventDefault();
        openExchangeModal();
      }}
      tabIndex={-1}
    >
      {children}
    </HintLink>
  );
};
